import { ThisConnector } from '../../../../../api/connector'
import { LatestUsedCredentials } from '../shared'

export interface GetLatestUsedCredentialsArgs {
  organizationUuid: string
  bugtracker: 'JIRA' | 'AGILE_CENTRAL'
}

export interface GetLatestUsedCredentialsResponse {
  credentials: LatestUsedCredentials
}

export async function getLatestUsedCredentials(
  this: ThisConnector,
  { organizationUuid, bugtracker }: GetLatestUsedCredentialsArgs
) {
  const { credentials } =
    await this.connector.get<GetLatestUsedCredentialsResponse>(
      `/${organizationUuid}/bugtrackers/${bugtracker}/credentials/latest?expand=skip_links`
    )
  return credentials
}
